import { render, staticRenderFns } from "./checkPhone.vue?vue&type=template&id=44c6cd90&scoped=true&"
import script from "./checkPhone.vue?vue&type=script&lang=js&"
export * from "./checkPhone.vue?vue&type=script&lang=js&"
import style0 from "./checkPhone.vue?vue&type=style&index=0&id=44c6cd90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c6cd90",
  null
  
)

export default component.exports